import React from 'react';
import { Button, Dialog, Grid, TableBody, TableCell, TableHead, TableRow, withStyles } from '@material-ui/core';

import axiosInstance, { EVENT_ID, getUserID, WEB_API } from '../constatns';
import Table from '../components/Table/Table';
import ReviewWin from './ReviewWin';

const styles = (theme) => ({
  reviewState: {
    paddingBottom: theme.spacing(1),
    fontSize: '1.1em',
    fontWeight: 550,
    '& span:first-child': {
      color: '#f00',
    },
    '& span:nth-child(2)': {
      color: theme.palette.secondary.main,
    },
    '& span:last-child': {
      color: '#00f',
    },
  },
  tableHead: {
    '& th': {
      padding: theme.spacing(2, 1),
      fontSize: '0.9em',
      lineHeight: 'normal',
    },
    '& tr th:not(:last-child)': {
      borderRight: '1px solid rgba(224, 224, 224, 1)',
    },
  },
  tableBody: {
    '& td': {
      padding: theme.spacing(2, 1),
      fontSize: '0.9em',
      textAlign: 'center',
    },
    '& tr td:not(:last-child)': {
      borderRight: '1px solid rgba(224, 224, 224, 1)',
    },
  },
});

class AbstractReview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      openReview: false,
      paperId: '',
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    axiosInstance.get(`${WEB_API}/paper/myReview?eventId=${EVENT_ID}&userId=${getUserID(true)}`).then((res) => {
      let buff = [];
      //   let inprocessArr = [];
      //   let completedArr = [];
      if (res.data.length > 0) {
        res.data.forEach((item) => {
          if (!item.Item.isDel || (item.Item.isDel && item.Item.isDel !== 1)) {
            buff.push(item.Item);
          }
          //   if (item.Item.status === 'In-Process') {
          //     inprocessArr.push(item.Item);
          //   }
          //   if (item.Item.status === 'Complete') {
          //     completedArr.push(item.Item);
          //   }
        });
        buff = buff.sort((a, b) => {
          if (a.id < b.id) {
            return -1;
          } else if (a.id > b.id) {
            return 1;
          } else {
            return 0;
          }
        });
        this.countStatus(buff);
        this.setState(
          { data: buff, totalCnt: buff.length /*, inprocessCnt: inprocessArr.length, completedCnt: completedArr.length */ },
          () => {
            // console.log(this.state.data);
          },
        );
      }
    });
  }

  openReviewWin(id) {
    // window.open(`/#/review?id=${id}`, '_blank', 'width=860, height=1000');
    this.setState({
      paperId: id,
      openReview: true,
    });
  }

  closeReviewWin() {
    this.setState({ openReview: false }, () => {
      this.loadData();
    });
  }

  renderTableBody(data) {
    const { classes } = this.props;
    return (
      <TableBody className={classes.tableBody}>
        {data.map((item, idx) => (
          <TableRow key={`review-data-${idx}`}>
            <TableCell>{idx + 1}</TableCell>
            <TableCell>{item.paperRegNo}</TableCell>
            <TableCell>{item.presentationType}</TableCell>
            <TableCell>{item.abstractTitle}</TableCell>
            {this.renderMyReview(item)}
            {/* <TableCell>
              {item.status ? (
                item.status === 'Complete' ? (
                  <span style={{ color: '#00f' }}>{item.status}</span>
                ) : (
                  <span style={{ color: '#f00' }}>{item.status}</span>
                )
              ) : (
                '-'
              )}
            </TableCell> */}
            <TableCell>
              <Button variant="contained" size="small" color="primary" disableElevation onClick={() => this.openReviewWin(item.id)}>
                Review
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    );
  }

  renderMyReview(data) {
    let buff = {};

    if (data.reviewResult) {
      for (let i = 0; i < data.reviewResult.length; i++) {
        if (data.reviewResult[i].reviewer === getUserID(true)) {
          buff['researchScore'] = data.reviewResult[i].researchScore;
          buff['originalityScore'] = data.reviewResult[i].originalityScore;
          buff['concreteScore'] = data.reviewResult[i].concreteScore;
          buff['practicalityScore'] = data.reviewResult[i].practicalityScore;
          buff['contributionScore'] = data.reviewResult[i].contributionScore;
          buff['totalScore'] = data.reviewResult[i].totalScore;
          buff['status'] =
            data.reviewResult[i].reviewStatus && data.reviewResult[i].reviewStatus.indexOf('Temporary') !== -1
              ? 'Temporary Save'
              : data.reviewResult[i].reviewStatus.indexOf('Complete') !== -1
              ? 'Complete'
              : 'In-Process';
          break;
        } else {
          buff['researchScore'] = '';
          buff['originalityScore'] = '';
          buff['concreteScore'] = '';
          buff['practicalityScore'] = '';
          buff['contributionScore'] = '';
          buff['totalScore'] = '';
          buff['status'] = 'In-Process';
          // break;
        }
      }
    } else {
      buff['researchScore'] = '';
      buff['originalityScore'] = '';
      buff['concreteScore'] = '';
      buff['practicalityScore'] = '';
      buff['contributionScore'] = '';
      buff['totalScore'] = '';
      buff['status'] = 'In-Process';
    }

    return (
      <>
        <TableCell>{buff.researchScore}</TableCell>
        <TableCell>{buff.originalityScore}</TableCell>
        <TableCell>{buff.concreteScore}</TableCell>
        <TableCell>{buff.practicalityScore}</TableCell>
        <TableCell>{buff.contributionScore}</TableCell>
        <TableCell>{buff.totalScore}</TableCell>
        <TableCell
          style={
            buff.status === 'Complete'
              ? {
                  color: '#00f',
                }
              : {
                  color: '#f00',
                }
          }
        >
          {buff.status}
        </TableCell>
      </>
    );
  }

  countStatus(data) {
    let inprocess = [];
    let completed = [];
    let temporary = [];

    for (let i = 0; i < data.length; i++) {
      let buff = {};
      if (data[i].reviewResult && data[i].reviewResult.length > 0) {
        for (let j = 0; j < data[i].reviewResult.length; j++) {
          if (data[i].reviewResult[j].reviewer === getUserID(true)) {
            buff['status'] =
              data[i].reviewResult[j].reviewStatus.indexOf('Temporary') !== -1
                ? 'Temporary'
                : data[i].reviewResult[j].reviewStatus.indexOf('Complete') !== -1
                ? 'Complete'
                : 'In-Process';
            break;
          } else {
            buff['status'] = 'In-Process';
          }
        }
      } else {
        buff['status'] = 'In-Process';
      }

      if (buff.status.indexOf('Complete') !== -1) {
        completed.push(buff);
      } else if (buff.status.indexOf('Temporary') !== -1) {
        temporary.push(buff);
      } else {
        inprocess.push(buff);
      }
    }

    this.setState({
      inprocessCnt: inprocess.length,
      temporaryCnt: temporary.length,
      completedCnt: completed.length,
    });
  }

  render() {
    const { classes } = this.props;
    const { data, totalCnt, inprocessCnt, completedCnt, temporaryCnt } = this.state;

    return (
      <>
        <Grid container>
          <Grid item xs={12}>
            <div className={classes.reviewState}>
              <span>In-process</span> {data && inprocessCnt} / <span>Temporary Save</span> {data && temporaryCnt} / <span>Completed</span>{' '}
              {data && completedCnt} (Total : {data && totalCnt})
            </div>
            <Table>
              <TableHead className={classes.tableHead}>
                <TableRow>
                  <TableCell width="3%">No</TableCell>
                  <TableCell width="10%">Abstract No.</TableCell>
                  <TableCell width="7%">Presentation Type</TableCell>
                  <TableCell width="26%">Abstract Title</TableCell>
                  <TableCell width="7%">학문적 가치</TableCell>
                  <TableCell width="7%">독창성</TableCell>
                  <TableCell width="7%">연구방법의 적절성</TableCell>
                  <TableCell width="7%">논리전개 및 결론도출</TableCell>
                  <TableCell width="7%">가산점</TableCell>
                  <TableCell width="7%">Total Score</TableCell>
                  <TableCell width="5%">Status</TableCell>
                  <TableCell width="7%">Abstract</TableCell>
                </TableRow>
              </TableHead>
              {this.renderTableBody(data)}
            </Table>
          </Grid>
        </Grid>

        {this.state.openReview ? (
          <Dialog
            open={this.state.openReview}
            maxWidth={'lg'}
            onClose={() => this.closeReviewWin()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <ReviewWin abstractId={this.state.paperId} handleClose={() => this.closeReviewWin()} />
          </Dialog>
        ) : null}
      </>
    );
  }
}

export default withStyles(styles, { withTheme: true })(AbstractReview);
